import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, EntityService, SharedService } from '@app/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnDestroy {
    private destroy$ = new Subject<void>();
  token: any;
  Owner = "Owner";
  Admin = "Admin";

  constructor(
    private readonly authService: AuthService,
    private readonly sharedService: SharedService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly entityService: EntityService) {

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
            const data = params['data'];

            if (data) {
              try {
                const parsedData: any = JSON.parse(atob(data));
                const user = JSON.parse(this.sharedService.decrypt(parsedData.user));
                this.authService.authenticate({ ...parsedData, user: user, expiry: new Date(parsedData.expiry) }, true);

                if ((user.role == this.Owner && user.isOnboarded) || user.role == this.Admin) {
                  this.entityService.fetchEntities().pipe(takeUntil(this.destroy$)).subscribe(entities => {
                                        this.entityService.setInitialEntities(entities, user);
                                        if (user.role == this.Owner) {
                                          this.router.navigate(['/dashboard']);
                                        } else if (user.role == this.Admin) {
                                          this.router.navigate(['/invoice']);
                                        }
                                      }, (error) => {
                                        console.log('error:', error);
                                      });
                } else {
                  this.router.navigate(['/dashboard']);
                }

              } catch (error) {
                console.log('error:', error);
                this.router.navigate(['/login']);
              }

            } else {
              this.router.navigate(['/login']);
            }

          });

  }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
